import { useEffect, useRef, useState } from "react";

const REVEAL_OPTIONS = { threshold: 0.12, rootMargin: "0px 0px -7% 0px" };

export const useScrollRevealItem = () => {
  const ref = useRef(null);
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    if (isRevealed) return undefined;

    const node = ref.current;
    if (!node) return undefined;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reducedMotion) {
      setIsRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsRevealed(true);
          observer.disconnect();
        }
      });
    }, REVEAL_OPTIONS);

    observer.observe(node);
    return () => observer.disconnect();
  }, [isRevealed]);

  return { ref, isRevealed };
};

export const useScrollReveal = (enabled, ...deps) => {
  useEffect(() => {
    if (!enabled) return undefined;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const nodes = document.querySelectorAll(
      "[data-scroll-reveal]:not([data-scroll-reveal-managed]):not(.is-revealed)"
    );

    if (!nodes.length) return undefined;

    if (reducedMotion) {
      nodes.forEach((node) => node.classList.add("is-revealed"));
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        }
      });
    }, REVEAL_OPTIONS);

    nodes.forEach((node) => observer.observe(node));

    return () => observer.disconnect();
  }, [enabled, ...deps]);
};
